var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudWatchSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "290px",
    height: "290px",
    viewBox: "-17 0 290 290",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,199.305 L128.043,180.508 L0,199.329 L128.01,246.768 L256,199.305",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.621,197.113 L47.251,203.874 L49.222,201.636 L49.222,50.284 L47.251,47.699 L25.621,55.973 L25.621,197.113",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.832,190.423 L47.251,203.874 L47.251,47.703 L123.832,64.925 L123.832,190.423",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.686,216.889 L59.838,207.688 L59.838,14.928 L89.686,0.004 L92.298,2.849 L92.298,213.707 L89.686,216.889",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.967,192.894 L89.686,216.889 L89.686,0 L191.967,39.866 L191.967,192.894",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.965,244.714 L0,199.329 L0,225.653 L127.965,289.636 L127.965,244.714",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,225.622 L127.965,289.636 L127.965,244.714 L256,199.305 L256,225.622",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.039,155.692 L189.013,155.692 L100.568,161.718 L128,166.775 L220.039,155.692",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.568,219.906 L127.988,228.132 L128.777,227.283 L128.754,165.434 L127.965,164.676 L100.568,161.718 L100.568,219.906",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.039,155.692 L127.965,164.672 L127.988,228.132 L220.039,200.421 L220.039,155.692",
    fill: "#759C3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudWatchSquare);
export default __webpack_public_path__ + "static/media/CloudWatchSquare.70e1c2ef.svg";
export { ForwardRef as ReactComponent };